module.exports = __webpack_public_path__ + "static/media/bgSubscription.c3cc04c1.jpg";